var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t)
    return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i)
        return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
} return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t.return && (u = t.return(), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
import { Avatar, ConversationHeader, MainContainer, MessageGroup, MessageInput, MessageList, TypingIndicator } from "@chatscope/chat-ui-kit-react";
import "@chatscope/chat-ui-kit-styles/dist/default/styles.min.css";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import chatChannel, { tabId } from "../../../channels/chats_channel";
import { ChatMessage, MessageContentType, MessageDirection, MessageStatus, useChat } from "../useChat";
import { checkIdExistsInMessages, getMessagesInConversation, parseLineMessageToChatMessage, uploadAdminImage } from "../utils/chat";
import { convertToString } from "../utils/helpers";
import useDebounceFn from "../utils/useDebounce";
import { CustomMessage } from "./CustomMessage";
import FileUploadButton from "./FileUploadButton";
import LeftSideBar from "./LeftSideBar";
import { MoreVertical } from "lucide-react";
import { ConversationMessageTemplates } from "./ConversationMessageTemplates";
import { useQueryParams } from "../utils/useQueryParams";
const ChatPage = () => {
    const queryParams = useQueryParams();
    const activeChatId = queryParams.get("chatId");
    const gender = queryParams.get("gender");
    const _useChat = useChat(), currentMessages = _useChat.currentMessages, activeConversation = _useChat.activeConversation, sendMessage = _useChat.sendMessage, getUser = _useChat.getUser, currentMessage = _useChat.currentMessage, setCurrentMessage = _useChat.setCurrentMessage, sendTyping = _useChat.sendTyping, addPreviousMessage = _useChat.addPreviousMessage, getMessagesByConversationId = _useChat.getMessagesByConversationId, removeAllMessageByStatus = _useChat.removeAllMessageByStatus, getState = _useChat.getState, updateConversation = _useChat.updateConversation, getConversation = _useChat.getConversation, addMessage = _useChat.addMessage, removeMessagesFromConversation = _useChat.removeMessagesFromConversation, removeMessageByMessagedId = _useChat.removeMessageByMessagedId, updateMessage = _useChat.updateMessage;
    const _useState = useState(1), _useState2 = _slicedToArray(_useState, 2), messagePage = _useState2[0], setMessagePage = _useState2[1];
    const _useState3 = useState(false), _useState4 = _slicedToArray(_useState3, 2), loading = _useState4[0], setLoading = _useState4[1];
    const _useState5 = useState(false), _useState6 = _slicedToArray(_useState5, 2), loadingMore = _useState6[0], setLoadingMore = _useState6[1];
    const _useState7 = useState(0), _useState8 = _slicedToArray(_useState7, 2), totalMessage = _useState8[0], setTotalMessage = _useState8[1];
    const _useState9 = useState(null), _useState0 = _slicedToArray(_useState9, 2), lastPage = _useState0[0], setLastPage = _useState0[1];
    const _useState1 = useState(false), _useState10 = _slicedToArray(_useState1, 2), isOpenTemplate = _useState10[0], setIsOpenTemplate = _useState10[1];
    const endMessageRef = useRef(null);
    const onYReachStartCount = useRef(0);
    const activeChatIdRef = useRef(activeChatId);
    const _useDebounceFn = useDebounceFn(700), debounce = _useDebounceFn.debounce;
    const _useMemo = useMemo(() => {
        if (activeConversation) {
            const participant = activeConversation.participants.length > 0 ? activeConversation.participants[0] : undefined;
            if (participant) {
                const user = getUser(participant.id);
                if (user) {
                    return [/*#__PURE__*/ React.createElement(Avatar, {
                            src: user.avatar,
                            onClick: () => window.open(`/userpage?id=${user.id}`, '_blank', 'noopener,noreferrer'),
                            onError: e => {
                                e.target.src = "/images/fallback/default.png";
                            },
                            className: "cursor-pointer"
                        }), /*#__PURE__*/ React.createElement("a", {
                            target: "_blank",
                            rel: "noopener noreferrer",
                            href: `/userpage?id=${user.id}`,
                            className: "text-lg"
                        }, user.username)];
                }
            }
        }
        return [undefined, undefined];
    }, [activeConversation, getUser]), _useMemo2 = _slicedToArray(_useMemo, 2), currentUserAvatar = _useMemo2[0], currentUserName = _useMemo2[1];
    const handleChange = value => {
        // Send typing indicator to the active conversation
        // You can call this method on each onChange event
        // because sendTyping method can throttle sending this event
        // So typing event will not be send to often to the server
        setCurrentMessage(value);
        if (activeConversation) {
            sendTyping({
                conversationId: activeConversation === null || activeConversation === void 0 ? void 0 : activeConversation.id,
                isTyping: true,
                userId: "user.id",
                content: value,
                // Note! Most often you don't want to send what the user types, as this can violate his privacy!
                throttle: true
            });
        }
    };
    const handleSend = text => {
        if (!(text === null || text === void 0 ? void 0 : text.length))
            return;
        // Stable client id so admin_message_ack can patch messagedId without reload.
        const clientId = `tmp-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
        const message = new ChatMessage({
            id: clientId,
            content: text,
            contentType: MessageContentType.TextHtml,
            senderId: "Admin",
            direction: MessageDirection.Outgoing,
            status: MessageStatus.Sent,
            messagedId: "",
            files: []
        });
        if (activeConversation) {
            sendMessage({
                message,
                conversationId: activeConversation.id,
                senderId: "Admin",
                generateId: false
            });
            const conversation = getConversation(activeConversation.id);
            if (conversation) {
                updateConversation(_objectSpread(_objectSpread({}, conversation), {}, {
                    description: text,
                    unreadCounter: 0,
                    data: _objectSpread(_objectSpread({}, conversation.data), {}, {
                        last_message: {
                            content: text,
                            time: new Date()
                        }
                    })
                }));
            }
            emitMessage(text, activeConversation.id, "text", clientId);
        }
    };
    const emitMessage = (content, user_id, message_type, clientId) => {
        chatChannel.perform("speak", {
            content,
            user_id,
            direction: "outgoing",
            message_type,
            tab_id: tabId,
            client_id: clientId,
            is_admin: true
        });
        scrollToBottom();
    };
    const handleSendImage = (files) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c;
        if (!activeChatId || !activeConversation) {
            return;
        }
        // Paint blob preview immediately (same UX as text), then patch after upload.
        const clientId = `tmp-img-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
        const blobUrls = Array.from(files).map(file => URL.createObjectURL(file));
        const pending = new ChatMessage({
            id: clientId,
            content: "",
            contentType: MessageContentType.Image,
            senderId: "Admin",
            direction: MessageDirection.Outgoing,
            status: MessageStatus.Pending,
            messagedId: "",
            files: blobUrls
        });
        sendMessage({
            message: pending,
            conversationId: activeConversation.id,
            senderId: "Admin",
            generateId: false
        });
        const conversation = getConversation(activeConversation.id);
        if (conversation) {
            updateConversation(_objectSpread(_objectSpread({}, conversation), {}, {
                description: "[画像]",
                unreadCounter: 0,
                data: _objectSpread(_objectSpread({}, conversation.data), {}, {
                    last_message: {
                        content: "[画像]",
                        time: new Date()
                    }
                })
            }));
        }
        scrollToBottom();
        const formData = new FormData();
        formData.append("chatId", activeChatId);
        formData.append("tab_id", tabId);
        formData.append("client_id", clientId);
        Array.from(files).forEach(file => {
            formData.append("files[]", file);
        });
        const res = yield uploadAdminImage(formData);
        if (!(res === null || res === void 0 ? void 0 : res.success)) {
            updateMessage(_objectSpread(_objectSpread({}, pending), {}, {
                status: MessageStatus.UnSync
            }));
            return;
        }
        const serverFiles = Array.isArray((_a = res.data) === null || _a === void 0 ? void 0 : _a.files) ? res.data.files : blobUrls;
        updateMessage(_objectSpread(_objectSpread({}, pending), {}, {
            messagedId: String((_c = (_b = res.data) === null || _b === void 0 ? void 0 : _b.message_id) !== null && _c !== void 0 ? _c : ""),
            files: serverFiles,
            status: MessageStatus.Sent
        }));
        blobUrls.forEach(url => URL.revokeObjectURL(url));
    });
    const getTypingIndicator = useCallback(() => {
        if (activeConversation) {
            const typingUsers = activeConversation.typingUsers;
            if (typingUsers.length > 0) {
                const typingUserId = typingUsers.items[0].userId;
                // Check if typing user participates in the conversation
                if (activeConversation.participantExists(typingUserId)) {
                    const typingUser = getUser(typingUserId);
                    if (typingUser) {
                        return /*#__PURE__*/ React.createElement(TypingIndicator, {
                            content: `${typingUser.username} is typing`
                        });
                    }
                }
            }
        }
        return undefined;
    }, [activeConversation, getUser]);
    const scrollToBottom = useCallback(() => {
        var _a;
        if (endMessageRef.current) {
            (_a = endMessageRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({
                behavior: "auto"
            });
        }
    }, [endMessageRef]);
    const fetchMessages = (chatId, page) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        const response = yield getMessagesInConversation(chatId, page);
        if ((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.length) {
            setTotalMessage(response.total);
            setLastPage(response.last_page);
            const messages = response === null || response === void 0 ? void 0 : response.data;
            messages.forEach(lm => {
                const message = parseLineMessageToChatMessage(lm);
                const currentMessages = getMessagesByConversationId(chatId);
                const isMessageExisted = checkIdExistsInMessages(currentMessages, message.messagedId);
                if (!isMessageExisted && message) {
                    addPreviousMessage(message, chatId, false);
                }
                removeAllMessageByStatus(MessageStatus.UnSync);
            });
        }
    });
    const handleOnYReachStart = (container) => __awaiter(void 0, void 0, void 0, function* () {
        if (onYReachStartCount.current > 0) {
            const messages = getState().currentMessages;
            let currentTotalMessage = 0;
            messages.forEach(m => {
                currentTotalMessage += m.messages.length;
            });
            if (loading === true || loadingMore === true || currentTotalMessage >= totalMessage || lastPage && messagePage > lastPage) {
                return;
            }
            if (activeChatId) {
                debounce(() => __awaiter(void 0, void 0, void 0, function* () {
                    var _a, _b;
                    setLoadingMore(true);
                    const response = yield getMessagesInConversation(activeChatId, messagePage);
                    if ((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.length) {
                        setTotalMessage(response.total);
                        setLastPage(response.last_page);
                        if ((_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.length) {
                            const messages = (response === null || response === void 0 ? void 0 : response.data) || [];
                            messages.forEach(lm => {
                                const message = parseLineMessageToChatMessage(lm);
                                const currentMessages = getMessagesByConversationId(activeChatId);
                                const isMessageExisted = checkIdExistsInMessages(currentMessages, message.messagedId);
                                if (!isMessageExisted && message) {
                                    addPreviousMessage(message, activeChatId, false);
                                }
                                removeAllMessageByStatus(MessageStatus.UnSync);
                                container.scroll({
                                    top: 100
                                });
                                setMessagePage(messagePage + 1);
                            });
                        }
                    }
                    setLoadingMore(false);
                }));
            }
        }
        else {
            onYReachStartCount.current += 1;
        }
    });
    useEffect(() => {
        if (activeChatId && messagePage) {
            activeChatIdRef.current = activeChatId;
            fetchMessages(activeChatId, messagePage);
            chatChannel.perform("mark_as_read", {
                user_id: activeChatId
            });
        }
        return () => {
            removeMessagesFromConversation(activeChatId);
        };
    }, [activeChatId, messagePage]);
    useEffect(() => {
        chatChannel.received = data => {
            var _a, _b, _c, _d, _e, _f, _g;
            if (data.event === "mark_as_read") {
                const conversation = getConversation(convertToString(data.user_id));
                if (conversation) {
                    updateConversation(_objectSpread(_objectSpread({}, conversation), {}, {
                        unreadCounter: 0
                    }));
                }
            }
            // Attach server id to optimistic outgoing bubble (same tab that sent).
            if (data.event === "admin_message_ack" && data.tab_id === tabId && ((_a = data.message) === null || _a === void 0 ? void 0 : _a.id)) {
                const conversationId = convertToString(data.user_id);
                const groups = getMessagesByConversationId(conversationId);
                let pending;
                if (data.client_id) {
                    for (const group of groups) {
                        pending = group.messages.find(m => String(m.id) === String(data.client_id));
                        if (pending)
                            break;
                    }
                }
                if (!pending) {
                    // Fallback: latest outgoing without a numeric server messagedId.
                    for (let gi = groups.length - 1; gi >= 0 && !pending; gi--) {
                        const msgs = groups[gi].messages;
                        for (let mi = msgs.length - 1; mi >= 0; mi--) {
                            const m = msgs[mi];
                            if (m.direction === MessageDirection.Outgoing && !/^\d+$/.test(String((_b = m.messagedId) !== null && _b !== void 0 ? _b : ""))) {
                                pending = m;
                                break;
                            }
                        }
                    }
                }
                if (pending) {
                    pending.messagedId = data.message.id;
                    if (data.message.created_at) {
                        pending.createdTime = new Date(data.message.created_at);
                    }
                    updateMessage(pending);
                }
                return;
            }
            // Admin soft-recall: hide bubble entirely (user app does the same).
            if (data.event === "admin_message_deleted" && ((_c = data.message) === null || _c === void 0 ? void 0 : _c.id)) {
                const conversationId = convertToString(data.user_id);
                removeMessageByMessagedId(data.message.id, conversationId);
                const conversation = getConversation(conversationId);
                if (conversation) {
                    const lastId = (_e = (_d = conversation.data) === null || _d === void 0 ? void 0 : _d.last_message) === null || _e === void 0 ? void 0 : _e.id;
                    if (!lastId || String(lastId) === String(data.message.id) || conversation.description) {
                        // Clear preview if the deleted message was likely the latest.
                        updateConversation(_objectSpread(_objectSpread({}, conversation), {}, {
                            description: "",
                            data: _objectSpread(_objectSpread({}, conversation.data), {}, {
                                last_message: {
                                    content: "",
                                    time: (_g = (_f = conversation.data) === null || _f === void 0 ? void 0 : _f.last_message) === null || _g === void 0 ? void 0 : _g.time
                                }
                            })
                        }));
                    }
                }
                return;
            }
            if (data.event === "new_message" && data.exclude_tab_id !== tabId) {
                const messageData = data.message;
                const conversation = getConversation(convertToString(data.user_id));
                if (conversation) {
                    const message = parseLineMessageToChatMessage(messageData);
                    const currentMessages = getMessagesByConversationId(conversation.id);
                    const isMessageExisted = checkIdExistsInMessages(currentMessages, message.messagedId);
                    if (!isMessageExisted && message) {
                        sendMessage({
                            message,
                            conversationId: conversation.id,
                            senderId: messageData === null || messageData === void 0 ? void 0 : messageData.user_id,
                            generateId: false
                        });
                    }
                    const preview = message.contentType === MessageContentType.Image ? "[画像]" : message.content;
                    updateConversation(_objectSpread(_objectSpread({}, conversation), {}, {
                        description: preview,
                        unreadCounter: (activeConversation === null || activeConversation === void 0 ? void 0 : activeConversation.id) === conversation.id ? conversation.unreadCounter : conversation.unreadCounter + 1,
                        data: _objectSpread(_objectSpread({}, conversation.data), {}, {
                            last_message: {
                                content: preview,
                                time: messageData.created_at
                            }
                        })
                    }));
                }
            }
            if (data.event === "client_new_message") {
                const messageData = data.message;
                const conversation = getConversation(convertToString(data.user_id));
                if (conversation) {
                    const message = parseLineMessageToChatMessage(messageData);
                    const currentMessages = getMessagesByConversationId(conversation.id);
                    const isMessageExisted = checkIdExistsInMessages(currentMessages, message.messagedId);
                    if (!isMessageExisted && message) {
                        sendMessage({
                            message,
                            conversationId: conversation.id,
                            senderId: messageData === null || messageData === void 0 ? void 0 : messageData.user_id
                        });
                    }
                    updateConversation(_objectSpread(_objectSpread({}, conversation), {}, {
                        description: message.content,
                        unreadCounter: (activeConversation === null || activeConversation === void 0 ? void 0 : activeConversation.id) === conversation.id ? conversation.unreadCounter : conversation.unreadCounter + 1,
                        data: _objectSpread(_objectSpread({}, conversation.data), {}, {
                            last_message: {
                                content: messageData.content,
                                time: messageData.created_at
                            }
                        })
                    }));
                }
            }
            if (data.event === "pinned_conversation" && data.user_id) {
                const conversation = getConversation(convertToString(data.user_id));
                if (conversation) {
                    const newConversation = _objectSpread(_objectSpread({}, conversation), {}, {
                        data: _objectSpread(_objectSpread({}, conversation.data), {}, {
                            pinned_conversation_at: data === null || data === void 0 ? void 0 : data.pinned_conversation_at
                        })
                    });
                    updateConversation(newConversation);
                }
            }
            if (data.event === "unpinned_conversation" && data.user_id) {
                const conversation = getConversation(convertToString(data.user_id));
                if (conversation) {
                    const newConversation = _objectSpread(_objectSpread({}, conversation), {}, {
                        data: _objectSpread(_objectSpread({}, conversation.data), {}, {
                            pinned_conversation_at: null
                        })
                    });
                    updateConversation(newConversation);
                }
            }
        };
        return () => {
            chatChannel.unsubscribe();
        };
    }, []);
    return /*#__PURE__*/ React.createElement("div", {
        className: "renew-chat-page relative",
        style: {
            height: "calc(100vh - 40px"
        }
    }, /*#__PURE__*/ React.createElement(MainContainer, {
        responsive: true
    }, /*#__PURE__*/ React.createElement(LeftSideBar, {
        activeChatId: activeChatId || "",
        gender: gender || ""
    }), /*#__PURE__*/ React.createElement("div", {
        className: "cs-chat-container",
        "data-anchor": "right",
        "data-template-open": isOpenTemplate
    }, activeConversation && /*#__PURE__*/ React.createElement(ConversationHeader, null, currentUserAvatar, /*#__PURE__*/ React.createElement(ConversationHeader.Content, {
        userName: currentUserName
    }), /*#__PURE__*/ React.createElement(ConversationHeader.Actions, null, /*#__PURE__*/ React.createElement("button", {
        onClick: () => setIsOpenTemplate(true)
    }, /*#__PURE__*/ React.createElement(MoreVertical, null)))), /*#__PURE__*/ React.createElement(MessageList, {
        typingIndicator: getTypingIndicator(),
        onYReachStart: handleOnYReachStart,
        disableOnYReachWhenNoScroll: true,
        autoScrollToBottom: true,
        autoScrollToBottomOnMount: true,
        loading: loading,
        loadingMore: loadingMore
    }, activeConversation && currentMessages.map(g => /*#__PURE__*/ React.createElement(MessageGroup, {
        key: g.id,
        direction: g.direction
    }, /*#__PURE__*/ React.createElement(MessageGroup.Messages, null, g.messages.map((m, index) => {
        const firstMessage = index === 0;
        return /*#__PURE__*/ React.createElement(CustomMessage, {
            key: m.id,
            direction: g.direction,
            message: m,
            isFirstMessage: firstMessage,
            emitMessage: emitMessage,
            activeConversation: activeConversation
        });
    })))), /*#__PURE__*/ React.createElement("div", {
        ref: endMessageRef
    })), activeConversation && /*#__PURE__*/ React.createElement("div", {
        className: "cs-message-custom-input flex w-full items-center"
    }, /*#__PURE__*/ React.createElement(FileUploadButton, {
        callback: handleSendImage
    }), /*#__PURE__*/ React.createElement(MessageInput, {
        value: currentMessage,
        onChange: handleChange,
        onSend: handleSend,
        sendButton: false,
        attachButton: false,
        placeholder: "Type here...",
        className: "py-2 flex-1 flex-grow bg-gray-100"
    }), /*#__PURE__*/ React.createElement("button", {
        onClick: () => handleSend(currentMessage),
        className: "bg-green-500 m-1.5 min-h-16 max-h-16 hover:bg-green-600 text-white font-medium px-8 rounded-2xl shadow-md transition duration-200 mr-4 w-48"
    }, "Send"))), /*#__PURE__*/ React.createElement("div", {
        className: `c-template-drawer fixed right-0 h-full bg-white transform ${isOpenTemplate ? "translate-x-0" : "translate-x-full"} transition-transform duration-300`,
        "data-open": isOpenTemplate
    }, /*#__PURE__*/ React.createElement(ConversationMessageTemplates, {
        onToggle: () => setIsOpenTemplate(false),
        onSelectTemplate: content => setCurrentMessage(content)
    }))));
};
export default ChatPage;
